import React from 'react'
import styled from 'styled-components'
import { Modal } from '../common'
import { DISCORD_URL } from '../constants'

export const SHOW_MAINTENANCE = false

const DOWN_UNTIL = {
  year: 2021,
  month: 4,
  day: 23,
  hour: 21,
  minute: 0,
  second: 0,
}

export function Maintenance() {
  const { year, month, day, hour, minute, second } = DOWN_UNTIL
  const downUntil = new Date(Date.UTC(year, month - 1, day, hour, minute, second))
  return (
    <Modal title="Maintenance" disableClose={true}>
      <Container>
        The system is temporarily unavailable due to maintenance. Service will be resumed by {downUntil.toString()}. You
        can check our{' '}
        <a href={DISCORD_URL} target="_blank">
          Discord
        </a>{' '}
        for announcements.
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  padding: 10px;
`
